export const MAP_MIN_ZOOM = 2;
export const MAP_MAX_ZOOM = 11.59;
